export default class BasicContactVendor {
    static get OpCity() {
      return this.getInstance('OpCity');
    }

    static get PrimeStreet() {
        return this.getInstance('PrimeStreet');
    }

    static get CoffmanProperties() {
        return this.getInstance('Coffman Properties');
    }

    static get Dezka() {
        return this.getInstance('Dezka');
    }

    static get MarketplaceHomes() {
        return this.getInstance('Marketplace Homes');
    }

    static get NewHomeExpertsDetroit() {
        return this.getInstance('New Home Experts - Detroit');
    }

    static get NewHomeExpertsLasVegas() {
        return this.getInstance('New Home Experts - Las Vegas');
    }

    static get NewHomeExpertsSarasota() {
        return this.getInstance('New Home Experts - Sarasota');
    }

    static get NHSAustin() {
        return this.getInstance('NHS Austin');
    }

    static get Movoto() {
        return this.getInstance('Movoto');
    }

    static fromKey(key) {
        const formTypeMap = {

            'OpCity': BasicContactVendor.OpCity,
            'PrimeStreet': BasicContactVendor.PrimeStreet,
            'Coffman Properties': BasicContactVendor.CoffmanProperties,
            'Dezka': BasicContactVendor.Dezka,
            'Marketplace Homes': BasicContactVendor.MarketplaceHomes,
            'New Home Experts - Detroit': BasicContactVendor.NewHomeExpertsDetroit,
            'New Home Experts - Las Vegas': BasicContactVendor.NewHomeExpertsLasVegas,
            'New Home Experts - Sarasota': BasicContactVendor.NewHomeExpertsSarasota,
            'NHS Austin': BasicContactVendor.NHSAustin,
            'Movoto': BasicContactVendor.Movoto,
        };
        return formTypeMap[key];
    }

    static getInstance(key) {
        if (!this.instances[key]) {
        this.instances[key] = new BasicContactVendor(key);
        }
        return this.instances[key];
    }

    constructor(name) {
        this.name = name;
    }

    toString() {
        return `${this.name}`;
    }
}

Object.defineProperty(BasicContactVendor, 'instances', { value: {} });
